import React from "react";
import "./../NetworkButtonModal.scss";
import { FaPlus } from "react-icons/fa";

const NetworkModalSecondPage = ({ previousPage, closeModal, currentUser, recipientEmail, error }) => {
  const errMessage = error?.[0]?.message ?? "";
  return error ? (
    <div>
      <div className="network-modal-second-page-text">
        <h3>Invitation Could Not Be Sent</h3>
        <p>
          <span className="bold-text">{recipientEmail || "N/A"}</span> has not been emailed a link to join. {errMessage}
        </p>
      </div>
      <div className="network-modal-second-page-buttons grid-row">
        <p className="invite-another-link grid-col-6" onClick={previousPage}>
          <FaPlus className="plus-icon" /> Invite another new member
        </p>
        <button className="usa-button usa-button-secondary close-btn grid-col-6" onClick={closeModal}>
          Close
        </button>
      </div>
    </div>
  ) : (
    <div>
      <div className="network-modal-second-page-text">
        <h3>Invitation Sent!</h3>
        <p>
          <span className="bold-text">{recipientEmail || "N/A"}</span> has been emailed a link to join{" "}
          <span className="bold-text">{currentUser.legal_bussiness_name || "N/A"}</span>. This invitation will expire
          after 7 days.
        </p>
      </div>
      <div className="network-modal-second-page-buttons grid-row">
        <p className="invite-another-link grid-col-6" onClick={previousPage}>
          <FaPlus className="plus-icon" /> Invite another new member
        </p>
        <button className="usa-button usa-button-secondary close-btn grid-col-6" onClick={closeModal}>
          Close
        </button>
      </div>
    </div>
  );
};

export default NetworkModalSecondPage;
